<template>
  <article class="user_view">
    <left-menu :deleted="numberOfDeleted"></left-menu>
    <modal-rectify  @cancel="onCancelRectify" @activate="onActivateRectify" v-if="modalRectifyActive" :turno="selected" :type="'alertas'"></modal-rectify>
    <section class="user_view__header">
      <div @click="$router.push({ path: '/urgentlist'})" class="back_button">
        <img src="./../../assets/img/icons/back-button.svg">
        <span>atrás</span>
      </div>


      <div class="user_view__header--info"> 
        <div>
          <h1>Alertas importantes</h1>
          <h4>Listado alertas para operador</h4>
          
        </div>
        <div>
          
          <div class="user_view__header--sec1" style="margin-top:0px">  
              <button :class="{'active':true}" @click="updateData()" class="secondary_button" >ACTUALIZAR</button>
          </div>
        </div>
        
      </div>
      <div style="width:100%; display:flex;justify-content:space-around;margin-top:15px" >
            <h3 style="font-family: Inter UI Regular;font-size: 13px;color: #4E5B71;font-weight:bolder;margin-left:-6%"><b>GUARDA</b></h3>
            <h3 style="font-family: Inter UI Regular;font-size: 13px;color: #4E5B71;font-weight:bolder;margin-left:-6%"><b>COMPAÑIA</b></h3>
            <h3 style="font-family: Inter UI Regular;font-size: 13px;color: #4E5B71;font-weight:bolder;margin-left:-6%"><b>TURNO</b></h3>
            <h3 style="font-family: Inter UI Regular;font-size: 13px;color: #4E5B71;font-weight:bolder;margin-left:-6%"><b>FECHA Y HORA ALERTA GENERADA</b></h3>
            <h3 style="font-family: Inter UI Regular;font-size: 13px;color: #4E5B71;font-weight:bolder;margin-left:-6%"><b>DISTANCIA</b></h3>
            <h3 style="font-family: Inter UI Regular;font-size: 13px;color: #4E5B71;font-weight:bolder;margin-left:-6%"><b>LATITUD</b></h3>
            <h3 style="font-family: Inter UI Regular;font-size: 13px;color: #4E5B71;font-weight:bolder;margin-left:-6%"><b>LONGITUD</b></h3>
            <h3 style="font-family: Inter UI Regular;font-size: 13px;color: #4E5B71;font-weight:bolder;margin-left:-6%"><b>ACCION</b></h3>
          
      </div>
      <div class="user_view__header--info" style="margin-top:21px"> 
        <div style="width:100%;max-height:66vh;overflow-y:scroll;">
          
          <div style="width:100%; display:inline-flex;" >
             <div style="width:100%;">
              
              
             
              <div class="user_view__header--audios" style="width:100%" >
                <div v-for="(aud,i) in importantAlerts" :key="i" style="display:flex;border-bottom:1px dotted gray;margin-bottom: 15px">
                  <h4 style="position:relative; display:list-item;margin-top:2px;cursor:pointer;max-width:11%; min-width:11%;"  @click="$router.push({ path: '/turn/'+ aud.alert_name.turn_id })" ><b>■ <u>{{aud.guard.name}}</u></b></h4>
                  <h4 style="position:relative;margin-top:2px;width: 4%;margin-left: 6%;">{{aud.company.name}}</h4>
                  <h4 style="position:relative;margin-top:2px;width: 6%;margin-left: 7%;">{{aud.alert_name.turn_id}}</h4>
                  <h4 style="position:relative; text-transform: uppercase;width: 10%;margin-left: 7%; ">{{aud.alert_name.created_at | parseDate }}</h4>
                  <h4 style="position:relative;width: 6%;margin-left: 13%;">{{aud.alert_name.data.guard_distance}}</h4>
                  <h4 style="position:relative;width: 4%;margin-left: 4%;">{{aud.alert_name.data.guard_coordinates[0] | parseFixed}}</h4>
                  <h4 style="position:relative;width: 5%;margin-left: 7%;">{{aud.alert_name.data.guard_coordinates[1] | parseFixed}}</h4>
                  <input type="radio" style="width: 1%; margin-left: 8%;" @click="numberOfRow(i)" :id="'radio'+i">  
                  
                </div>
                <h4  v-if="importantAlerts.length == 0" style="text-align: center; margin-top:33px">
                    No se han encontrado audios con alta importancia.
                </h4>
              </div>
              
            </div>
             
              
            
          </div>      
        
         
        </div>   
            
      </div>
     
      
    </section>
    
  </article>
</template>

<script>
import moment from 'moment';
import 'moment/locale/es'
export default {

  filters: {
    parseDate (val) {
      try {
        return moment(val).calendar()
      } catch (e) {
        console.error('error parsing date with error message ', e.message)
        return val
      }
    },
    parseFixed(val){
      return parseFloat(val).toFixed(6)
    }
  },
  data(){
    return{
      subtitulo:'Guarda           Radio Operador',
      reports:[],
      reportes:{},
      is_diurnal: true,
      importantAlerts:[],
      modalRectifyActive:false,
      selected:null,
      reloading:true,
      numberOfDeleted:0,
    }
  }, 
  methods:{
    updateData(){
      const customActions={
        post: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'POST'}                   
      };
      this.$resource('guards/dashboard/create_alert',{},customActions).post({'company':this.$route.params.id})
      .then(function(data){
        console.log("REPORT");
        console.log(data);
        var allMyData=data.body.reverse();
        var alerts=[];
        for(var element in allMyData){
          let newAlert={"id":allMyData[element].id,"alert_name":allMyData[element].alert_name}
          alerts.push(newAlert);
        } 
        
        this.importantAlerts=alerts;
      });
    },
    numberOfRow(row){   
     
      this.selected=this.importantAlerts[row];
      this.modalRectifyActive=true;
      document.getElementById("radio"+row).checked=false;
      
            
    },
    onCancelRectify(){
      this.modalRectifyActive=false;
    },
    onActivateRectify(data){

      var self = this;
      
      const customActions = {
        review: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'DELETE'}                   
      };
      this.$resource('administrators/dashboard/delete_alert/'+self.selected.id,{
        comments: data[2],
        whoReviews: data[3]
      },customActions).review()
      .then(function(data){
        console.log('Alarma revisada: ',data.body)
        this.modalRectifyActive=false;       
        self.$router.go();
      });
    },
  },

  
  created(){
    const customActions={
        post: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'POST'}                   
    };
    this.$resource('guards/dashboard/create_alert',{},customActions).post({'company':this.$route.params.id})
    .then(function(data){
      var allMyData = data.body.reverse();
      var alerts = [];
      allMyData.forEach(element => {
        alerts.push({
          id: element.id,
          alert_name: element.alert_name,
          guard: element.guard,
          company: element.company
        })
      });
      
      this.importantAlerts=alerts;

    }).catch(error => {
      console.log('ERROR AL CONSULTAR LAS ALERTAS', error)
    });
    
  },

  
}
</script>


// WEBPACK FOOTER //
// src/components/pages/UrgentAlerts.vue